/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* api.module.ts
* 14-2-2020 - Jelmer Jellema - Spin in het Web B.V.
*
* Aparte module voor de api, om wat imports te isoleren.
*/

import {NgModule} from '@angular/core';
import {ToastrModule} from 'ngx-toastr';
import {SpinJS, SihwcacheService, SihwconfirmService} from 'sihw-ngx';
import {ApiService} from './api.service';

@NgModule({
  declarations: [],
  imports: [
    //npm
    ToastrModule.forRoot({
      timeOut: 7500,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true
    }), //ngx-toastr https://www.npmjs.com/package/ngx-toastr
  ],
  providers: [ApiService, SpinJS, SihwcacheService, SihwconfirmService]
}) export class ApiModule {}
